import { jsx as o } from "react/jsx-runtime";
import { ProductTypeEnum as t } from "./enums/product-type-enum.mjs";
import u from "./product-download/thumbnail.mjs";
import m from "./e-course/thumbnail.mjs";
import c from "./physical-product/thumbnail.mjs";
const l = ({
  ...r
}) => {
  switch (r.productType) {
    case t.download:
      return /* @__PURE__ */ o(u, { ...r });
    case t.eCourse:
      return /* @__PURE__ */ o(m, { ...r });
    case t.physicalProduct:
      return /* @__PURE__ */ o(c, { ...r });
  }
};
export {
  l as default
};
